/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The access rule a catalog platform produces.
 */
export type WorkloadPlatformSubject = {
  /**
   * The subject with {key} placeholders for rule-tier variables; the stem, for a wildcard rule.
   */
  template: string;
  /**
   * Whether the rule is the filled template followed by *.
   */
  wildcard: boolean;
};

/** @internal */
export const WorkloadPlatformSubject$inboundSchema: z.ZodMiniType<
  WorkloadPlatformSubject,
  unknown
> = z.object({
  template: z.string(),
  wildcard: z.boolean(),
});

export function workloadPlatformSubjectFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadPlatformSubject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadPlatformSubject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadPlatformSubject' from JSON`,
  );
}
